/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Meta_DescInputs */

const en_wc_tut_meta_desc = /** @type {(inputs: Wc_Tut_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn WordCraft step by step: the ribbon, styles, lists, tables, pictures, track changes, references, PDF export, keyboard shortcuts and the CLI.`)
};

/**
* | output |
* | --- |
* | "Learn WordCraft step by step: the ribbon, styles, lists, tables, pictures, track changes, references, PDF export, keyboard shortcuts and the CLI." |
*
* @param {Wc_Tut_Meta_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_meta_desc = /** @type {((inputs?: Wc_Tut_Meta_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Meta_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_meta_desc(inputs)
});
export { wc_tut_meta_desc as "wc.tut.meta_desc" }